import { useState } from 'react';
import { resolveAvatarUrl } from '../lib/avatarUrl';

function ResolvedAvatar({ src, children, ...imageProps }) {
  const [failed, setFailed] = useState(false);
  if (!src || failed) return children;
  return <img {...imageProps} src={src} onError={() => setFailed(true)} />;
}

// A changed URL (including its cache-buster) gets fresh error state. A failure
// renders the existing non-image placeholder, so it cannot retry recursively.
export default function AvatarImage({ src, children, ...imageProps }) {
  const resolved = resolveAvatarUrl(src);
  return <ResolvedAvatar key={resolved || 'missing'} src={resolved} {...imageProps}>{children}</ResolvedAvatar>;
}
